import { useState } from 'react';
import { useTexts } from '../../../../contexts/TextsContext';
import { useData } from '../../../../contexts/DataContext';
import { resolveAssetUrl } from '../../../../utils/utils';
import classes from './header.module.scss';

const Header = () => {
    const texts = useTexts();
    const { nav } = useData();
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className={classes.Header}>
            <div className={classes.Inner}>
                <div className={classes.Brand}>
                    <a href="/" className={classes.Logo}>
                        <img src={resolveAssetUrl('/assets/logo/skillz-logo.png')} alt="SKILLZ" className={classes.LogoImage} />
                    </a>

                    <nav id="main-nav" className={`${classes.Nav} ${menuOpen ? classes.NavOpen : ''}`}>
                        <ul className={classes.NavList}>
                            {nav.map(({ id, textKey }) => (
                                <li key={id} className={classes.NavItem}>
                                    <a href={`#${id}`} className={classes.NavLink} onClick={() => setMenuOpen(false)}>
                                        {texts[textKey]}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>

                <button
                    type="button"
                    className={classes.MenuToggle}
                    aria-label={texts.menuToggleLabel ?? 'תפריט'}
                    aria-expanded={menuOpen}
                    aria-controls="main-nav"
                    onClick={() => setMenuOpen((prev) => !prev)}
                >
                    <span className={classes.MenuBar} aria-hidden="true" />
                    <span className={classes.MenuBar} aria-hidden="true" />
                    <span className={classes.MenuBar} aria-hidden="true" />
                </button>
            </div>
        </header>
    );
};

export default Header;
